<template>
    <aside id="navbar">
        <MiddleMenu @reloadSameRoute="onReloadSameRoute"/>
        <BottomMenu/>
    </aside>
</template>

<script setup>
import MiddleMenu from '@/components/includes/menu/MiddleMenu';
import BottomMenu from '@/components/includes/menu/BottomMenu';

const emit = defineEmits(['reloadSameRoute'])

function onReloadSameRoute(){
    emit('reloadSameRoute')
}

</script>

<style scoped>

aside {
    background: #f7f7f7;
    border-right: 1px #ddd solid;
    width: 255px;
    position: fixed;
    top: 0;
    z-index: 999;
    margin-top: 60px;
    border-top: 1px #ddd solid;
}

@media screen and (min-width: 993px) {
    aside {
        height: 100% !important;
    }
}

@media screen and (max-width: 992px) {
    aside {
        width: 100% !important;
        height: 0px;
        overflow: hidden;
        border: none;
        border-bottom: 1px #ddd solid;
        border-right: 1px #ddd solid;
    }
}
</style>